import React, { Component } from 'react';
import { Button, Form, Input, Select, Divider, Row, Col, Modal } from 'antd';
import { ChurchRevivalFields } from "./churchRevivalFields";
import { ChurchPastorFields } from "./churchPastorFields";

import "./churchForm.css";

const FormItem = Form.Item;
const TextArea = Input.TextArea;

export default class NewChurchForm extends Component {
  constructor(props) {
    super(props);
    this.state = { pastors: [] };
  }

  onCancel = () =>{
    Modal.confirm({
      title: "Are you sure you want to leave without saving changes?",
      okText: "Leave",
      width: 600,
      onOk: () => this.props.history.push('/dashboard/admin/churches')
    });
  };

  addNewPastor = () => {
    const pastors = this.state.pastors;
    pastors.push({ key: pastors.length });
    this.setState({ pastors: pastors });
  };

  deletePastor(index) {
    const pastors = this.state.pastors;
    pastors.splice(index, 1);
    this.setState({ pastors: pastors });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { church } = this.props;

    return (
      <div>
        <div className="m-24">
          <Form onSubmit={this.props.onSubmit} className="login-form">
            <h3 className="church-form__step-header">1. Church overview</h3>
            <div className="m-24">
              <FormItem label="Name">
                {getFieldDecorator('name', {
                  rules: [
                    { required: true, message: 'Please specify Church name' }
                  ],
                  initialValue: church && church.name
                })(
                  <Input placeholder="Church name" />
                )}
              </FormItem>
              <div>
                { this.props.churchCodeField }
              </div>
              { this.props.timezoneField }
              <div>
                { this.props.evangelistsField }
              </div>
              <FormItem label="Church size">
                {getFieldDecorator('size', {
                  initialValue: church && church.size
                })(
                  <Input placeholder="# of Church members and Classes" />
                )}
              </FormItem>
              <FormItem label="Address (Main Campus)">
                {getFieldDecorator('address_line_1', {
                  initialValue: church && church.addressLine1
                })(
                  <TextArea placeholder="Address (Main Campus)" />
                )}
              </FormItem>
              <FormItem label="Contact person">
                {getFieldDecorator('contact_person', {
                  initialValue: church && church.contactPerson
                })(
                  <TextArea placeholder="Name and Occupation, phone #, email address" />
                )}
              </FormItem>
              <FormItem label="Notes">
                {getFieldDecorator('notes', {
                  initialValue: church && church.notes
                })(
                  <TextArea placeholder="Notes" />
                )}
              </FormItem>
            </div>
            <Divider/>
            <h3 className="church-form__step-header">2. Event Schedule</h3>
            <div className="m-24">
              <ChurchRevivalFields form={this.props.form} church={church}/>
            </div>
            <Divider/>
            <h3 className="church-form__step-header">3. Groups</h3>
            <div className="m-24">
              { this.props.groupsField }
            </div>
            <Divider/>
            <h3 className="church-form__step-header">4. Pastors</h3>
            <div className="m-24">
              { this.props.pastorsList }
              {
                !church &&
                <div>
                  <div className="church-form__pastor-header-block">
                    Senior Pastor*
                  </div>
                  <ChurchPastorFields form={this.props.form}/>
                </div>
              }
              <div className="church-form__pastor-header-block">
                Pastor
              </div>
              {
                this.state.pastors.map((pastor, index) => {
                  return (
                    <Row key={pastor.key}>
                      <Col span={22}>
                        <ChurchPastorFields index={pastor.key} form={this.props.form} type="pastors"/>
                      </Col>
                      <Col xs={{span: 24}} md={{span: 2}}>
                        <Button onClick={() => { this.deletePastor(index) }} type="primary">
                          Delete pastor
                        </Button>
                      </Col>
                    </Row>
                  );
                })
              }
              <div className="align-right">
                <Button className="church-form__control-item" type="primary" onClick={this.addNewPastor}>
                  Add pastor
                </Button>
              </div>
            </div>
            <Row type="flex" justify="end">
              <Col xs={{span: 24}} lg={{offset: 1, span: 10}}>
                <div className="align-right profile-form__form-control">
                  <Button onClick={this.onCancel} className="profile-form__inactive-button church-form__control-item">
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit" className="profile-form__submit-button church-form__control-item" loading={this.state.loading}>
                    Save church profile
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churches/form/churchForm.js